import { get, put, post, del } from "./index";
export function getList(params) {

    return get('/api/admin/song', params);
}
export function update(id, params) {
    return put(`/api/admin/song/${id}`, params);
}
export function add(params) {
    return post('/api/admin/song', params);
}
export function getDetails(id) {

    return get(`/api/admin/song/${id}`);
}
export function strike(id) {
    return del(`/api/admin/song/${id}`);
}
export function getReview(data) {
    return post('/api/admin/song/review', data);
}
export function updateReview(id, data) {
    return put(`/api/admin/song/review/${id}`, data);
}